import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const FORM_TEMP_CONSTANTS = {
  ADD_PAGE_TITLE: "Agregar formulario",
  ADD_FIELD_TITLE: "Agregar un nuevo campo",
  EDIT_FIELD_TITLE: "Editar campo",
  PAGE_TITLE: "Formularios",
  PAGE_TITLE_SEARCH: "Consulta de formularios",
  EDIT_PAGE_TITLE: "Editar formulario",
  FIELDS_TITLE: "Campos",
  EVENTS: {
    RULE: {
      ADD_NEW: "addNewRule",
      ADD_EDITED: "addEditedRule",
      EDIT_GIVEN_RULE: "editGivenRule",
      EDIT: "editRule",
      DELETE: "deleteRule"
    },
    FIELD: {
      ADD_NEW: "addNewField",
      ADD_EDITED: "addEditedField",
      SAVE_NEW_ORDER: "saveNewFieldOrder",
      EDIT: "editField",
      DELETE: "deleteField",
      ADD_NEW_FIELD_CONDITIONAL_FORM: "addFieldConditionalForm"
    },
    CONDITION: {
      ADD_NEW: "addNewCondition",
      ADD_EDITED: "addEditedCondition",
      EDIT: "editCondition",
      DELETE: "deleteCondition",
      FIELD: {
        ADD_NEW_CONDITION: "addNewConditionField",
        ADD_EDITED_CONDITION: "addEditedConditionField",
        SAVE_NEW_ORDER: "saveConditionalFieldOrder",
        EDIT: "editConditionalField",
        DELETE: "deleteConditionalField",
        MODIFY: "modifyConditionalField"
      },
      CLEAR_CONDITION_FORM: "clearConditionForms",
      MODIFY: "modifyCondition"
    },
    CLOSE_DIALOG: "closeDialog",
    ADD_ELEMENT: "addElement",
    GET_DATA_MAIN_VIEW: "getDataToMainView"
  },
  SUMMARY_LABEL: {
    DATA: "Resumen",
    TEXT: "Resumen del campo*"
  },
  FIELD_LABEL: {
    EMPTY_STATE_HEADER: "No se han agregado campos aún",
    EMPTY_STATE_PARAGRAPH: "Agrega campos al formulario"
  },
  RULE_LABEL: {
    FORM_TEXT: "Notas",
    EMPTY_STATE_TITLE: "No se han agregado reglas aún",
    EMPTY_STATE_PARAGRAPH: "Agrega texto resumen al formulario",
    TITLE_DATA: "Texto complementario",
    ADD_TITLE: "Agregar texto complementario",
    EDIT_TITLE: "Editar texto complementario",
    TITLE: "Nombre regla*",
    TEXT_DESCRIPTION: "Texto de la regla*"
  },
  CONDITION_LABEL: {
    EMPTY_STATE_TITLE: "No se han agregado condiciones aún",
    EMPTY_STATE_PARAGRAPH: "Agrega condiciones al formulario",
    ADD_TITLE: "Agregar condición",
    EDIT_TITLE: "Editar condición",
    TITLE_DATA: "Campos condicionales",
    TITLE: "Nombre de la condición*"
  },
  FORM_LABEL: {
    CATEGORY: "Categoría: ",
    TYPE: "Tipo: ",
    STATUS: "Estado: ",
    DATE_CREATED: "Fecha creado: ",
    DATE_CHANGED: "Fecha modificado: ",
    VERSION: "Versión: "
  },
  ADD_TEMPLATE_TEXT: "Crear formulario",
  LABEL: {
    FORM_NAME: "Nombre formulario*",
    FORM_TYPE: "Tipo de formulario*",
    URL_IMG: "URL Imagen de ayuda",
    URL_ICON: "Icono",
    FORM_CATEGORY: "Categoría*",
    HELP_TEXT: "Texto de ayuda",
    TITLE: "Título*",
    CONVERSATION_TITLE: "Título conversacional",
    VISIBLE: "Visible",
    EDITABLE: "Editable",
    REQUIRED: "Requerido",
    INDICATOR: "Indicador",
    CONDITIONAL: "Condicional",
    VISUAL_ELEM: "Elemento visual*",
    MIN_VALUE: "Valor mínimo*",
    MAX_VALUE: "Valor máximo*",
    STEP: "Valor de paso",
    ADD_VALUES: "Agregue los valores",
    FIELD_TYPE: "Tipo de campo*",
    DATA_TYPE: "Tipo de dato*",
    HINT: "Para agregar un nuevo valor presione enter",
    SEARCH_LIST: "Búsqueda de lista",
    ADD_LIST: "Elección de lista*",
    HINT_SEARCH_LIST: "Seleccione una lista",
    HINT_LIST: "Escriba el nombre de la lista y presiona enter para buscar",
    FIELD: "Campo",
    OPERATOR: "Operador",
    VALUE: "Valor",
    CONDITION: "Elija la condición",
    INFO_FORM: "Información adicional del formulario",
    INFO_FIELD: "Información adicional del campo",
    FIELD_CONFIG: "Configuración del campo",
    FORM_MULTIPLES_NOT: " no permite multiples formularios"
  },
  MODAL: {
    OUTDATED_TEMPLATE: "Actualizaciones"
  },
  BUTTON: {
    SAVE_DRAFT: "Subir Borrador",
    ADD_FIELD: "Campo",
    ADD_RULE_BTN: "Texto complementario",
    ADD_FORM: "Agregar formulario",
    ADD_CONDITION: "Condición"
  },
  MESSAGE: {
    MAX_LENGTH: "Máximo 300 caracteres",
    MIN_FIELDS: "Debe agregar al menos un campo.",
    EXISTING_ITEM: "Ya existe elemento en la lista",
    MAX_CONDITION_FIELD: "Solo puede haber una condición por campo.",
    MIN_VAL_FIELD: "Valor mínimo debe ser menor a",
    MAX_VAL_FIELD: "Valor máximo debe ser mayor a"
  },
  FIELD_TYPE: {
    BASIC: "basico",
    LIST: "lista",
    FORMULA: "formula",
    STRING: "string",
    NUMBER: "number",
    SLIDER: "slider",
    CHECKBOX: "checkbox",
    RADIO: "radio",
    DATE: "date",
    BOOLEAN: "boolean",
    EMAIL: "email"
  },
  DISPLAY_TYPES: {
    CHECKBOX: "checkbox",
    RADIO: "radio",
    CUSTOM_SELECT: "custom-select"
  },
  FORM_TEMPLATES_ROUTE: "/form-templates",
  DRAFT_STATUS: "Borrador",
  DIALOG_MESSAGE: {
    ERROR_ID_NOT_FOUND: "El formulario a eliminar no existe",
    FORM_TEMP_CANT_DELETE: "La plantilla de formulario no se puede eliminar",
    ERROR: "Ocurrio un error"
  },
  FORMULA_TEXT: "Campos disponibles para la fórmula:",
  TOOLTIP: "Cambiar Grafica",
  TOOLTIP_ADD_BTN: "Crear formulario",
  TOOLTIP_CANCEL_BTN: "Cancelar",
  CREAR_FORMULARIO: "crearFormulario",
  EDITAR_FORMULARIO: "editarFormulario",
  CREATE_LIST: "Crear Lista",
  OPTIONS_PANEL: [
    {
      value: "showAddList",
      srcImg: "search.png",
      name: "Agregar Lista"
    }
  ],
  CONDITIONAL_COMPONENT_TOOLTIPS: {
    BTN_TOOLTIPS: {
      EDIT_CONDITION: "Editar Condición",
      DELETE_CONDITION: "Eliminar Condición",
      ADD_FIELD: "Agregar Campo"
    }
  },
  FIELD_COMPONENT_TOOLTIPS: {
    BTN_TOOLTIPS: {
      EDIT_FIELD: "Editar Campo",
      DELETE_FIELD: "Eliminar Campo",
      ADD_CONDITION: "Agregar Condición"
    }
  },
  RULE_COMPONENT_TOOLTIPS: {
    BTN_TOOLTIPS: {
      EDIT_RULE: "Editar Regla",
      DELETE_RULE: "Eliminar Regla"
    }
  },
  FIELD_CONDITIONAL_COMPONENT_TOOLTIPS: {
    BTN_TOOLTIPS: {
      EDIT_FIELD: "Editar Campo",
      DELETE_FIELD: "Eliminar Campo"
    }
  },
  SAVE_FORM_MODAL_ID: "formTemplateForm",
  CONDITION_SLIDER_FIELD: {
    MINIMUM_MIN_VALUE: 0,
    MINIMUM_MAX_VALUE: 1
  }
};

export const DATA_TYPE = {
  string: [
    { label: "String", value: "string" },
    { label: "Numérico", value: "number" },
    { label: "Fecha", value: "date" }
  ]
};

export const DATA_TYPE_SIMPLE = {
  radio: "string",
  checkbox: "array",
  select: "string",
  slider: "number",
  switch: "boolean",
  textarea: "string"
};

export const VISUAL_ELEMENT_TYPE = {
  basico: [
    { label: "Input", value: "string" },
    { label: "Radio", value: "radio" },
    { label: "Checklist", value: "checkbox" },
    { label: "Slider", value: "slider" },
    { label: "Toggle", value: "switch" },
    { label: "Texto", value: "textarea" }
  ],
  lista: [
    { label: "Select", value: "select" },
    { label: "Radio", value: "radio" },
    { label: "Checklist", value: "checkbox" }
  ]
};

export const FORM_TEMP_VALIDATORS = {
  MAX_LENGTH: (v: string) =>
    v.length <= 300 || FORM_TEMP_CONSTANTS.MESSAGE.MAX_LENGTH
};

export const FIELD_TYPE = [
  { label: "Campo básico", value: "basico" },
  { label: "Lista", value: "lista" },
  { label: "Fórmula", value: "formula" }
];
export const FORM_CATEGORY = [
  "General",
  "Administrativo",
  "Clínico",
  "Básico",
  "Formulario"
];

export const FORMULA_TYPE = {
  ERRORS: {
    SYNTAX: "La fórmula presenta una sintaxis incorrecta",
    FIELD_NOT_FOUND: "Seleccione un campo del formulario"
  },
  HELPER: "** Potenciación, * Multiplicación"
};

export const FILTER_DATA = {
  collection: "forms",
  form: {},
  bigSearch: false
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Formulario",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE
  },
  {
    name: "Categoria",
    placeholder: "Categoria de Formulario",
    key: "category",
    avatar: "mdi-shape",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: FORM_CATEGORY.map(data => ({ key: data, name: data }))
  },
  {
    name: "Estado",
    placeholder: "Estado de Formulario",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" },
      { name: "Borrador", key: "Borrador" }
    ]
  }
];

export const FORM_FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "forms",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS
  }
];

export const KEYTYPE_CONSTANTS = {
  OBJECT: "object",
  DEEPLEVEL: "deepLevel",
  UNDEFINED: "undefined",
  BOOLEAN: "boolean",
  DOCQRYDTO: "DocumentQueryDTO"
};

export const ESCHEMA_TYPES = {
  STRING: "string",
  ARRAY: "array",
  NUMBER: "number",
  BOOLEAN: "boolean",
  LIST: "lista"
};

export const DISPLAY_TYPES = {
  RADIO: "radio",
  AUTOCOMPLETE: "autocomplete",
  STRING: "string",
  CHECKBOX: "checkbox",
  DATE: "date"
};
export const MISSING_LIST_ERROR =
  "Debe seleccionar una lista para el campo de tipo lista";

export const CHART_DATA = {
  CHART_TITLE: {
    CATEGORY: "Categorías",
    STATE: "Estados"
  },
  CHART_PARAM: {
    CATEGORY: "category",
    STATE: "state"
  }
};

export const FORM_TEMPLATES_ACCESS = {
  ALL: "plantillas de formulario",
  GET: "consultar plantillas de formulario",
  POST: "crear plantillas de formulario",
  PUT: "modificar plantillas de formulario",
  DELETE: "eliminar plantillas de formulario"
};

export const UNAVALIBLE_TO_EDIT_BY_CONDITION =
  "Condicion Activa, no se puede editar";

export const DATE_ID = "date";
